import { AppBar, Stack, Toolbar, Typography } from '@mui/material';
import ActionsMenu from './ActionsMenu';
import { useDocumentContext } from './DocumentContext';
import PageNumberNavigation from './PageNumberNavigation';
import HideOnScroll from './Utilities/HideOnScroll';

export default function ReadingViewHeader() {
  const { productMeta } = useDocumentContext();

  return (
    <HideOnScroll>
      <AppBar
        position='fixed'
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: (theme) => theme.palette.background.default,
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Stack
            direction='row'
            alignItems='center'
            gap={2}
            justifyContent='space-between'
            sx={{
              paddingLeft: 2,
              width: '100%',
              minWidth: 0,
            }}
          >
            <Typography
              component='p'
              variant='h5'
              color='text.secondary'
              noWrap
              sx={{
                fontSize: 18,
                lineHeight: '130%',
                letterSpacing: '0.25px',
              }}
            >
              {productMeta?.title}
            </Typography>
            <PageNumberNavigation />
          </Stack>
          <ActionsMenu />
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  );
}
